<div class="page-wrapper">
  <div class="auth-bg">
    <div class="authentication-box">
      <div class="text-center">
        <img src="assets/images/logo-vetcant.svg" alt="" width="200" />
      </div>
      <div class="card mt-4">
        <div class="card-body">
          <div class="text-center">
            <h4>CONTROL DE ACCESO</h4>
            <h6>Ingresa tu correo electrónico y contraseña</h6>
          </div>
          <form class="theme-form" [formGroup]="loginForm" *ngIf="!newUser">
            <div class="form-group">
              <label class="col-form-label pt-0">Email</label>
              <input
                class="form-control"
                formControlName="email"
                type="email"
                required=""
              />
              <div
                *ngIf="
                  loginForm.controls.email.touched &&
                  loginForm.controls.email.errors?.required
                "
                class="text text-danger mt-1"
              >
                Correo electrónico es requerido
              </div>
              <div
                *ngIf="
                  loginForm.controls.email.touched &&
                  loginForm.controls.email.errors?.email
                "
                class="text text-danger mt-1"
              >
                Corre inválido
              </div>
            </div>
            <div class="form-group">
              <label class="col-form-label">Contraseña</label>
              <input
                class="form-control"
                type="password"
                formControlName="password"
                required=""
              />
              <div
                *ngIf="
                  loginForm.controls.password.touched &&
                  loginForm.controls.password.errors?.required
                "
                class="text text-danger mt-1"
              >
                Contraseña es requerida
              </div>
            </div>
            <div class="checkbox p-0">
              <input id="checkbox1" type="checkbox" />
              <label for="checkbox1">Recuerdame</label>
            </div>
            <div class="form-group row mt-3 mb-0">
              <button
                class="btn btn-primary btn-block btn-lg"
                [class.loader--text]="authService.showLoader"
                [disabled]="!loginForm.valid || authService.showLoader"
                (click)="login(loginForm.value)"
                type="submit"
              >
                <span>{{
                  authService.showLoader ? "" : "Iniciar sesión"
                }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
